import ApiService from '@/services/api';

const API = new ApiService();

export const state = {
  provinces: [],
  cities: [],
  barangays: [],
  regions: [],
  countries: []
}

export const mutations = {
  SET_PROVINCES(state, provinces) {
    state.provinces = provinces;
  },
  SET_CITIES(state, cities) {
    state.cities = cities
  },
  SET_BARANGAYS(state, barangays) {
    state.barangays = barangays;
  },
  SET_REGIONS(state, regions) {
    state.regions = regions;
  },
  SET_COUNTRIES(state, countries) {
    state.countries = countries;
  }
}

export const getters = {}

export const actions = {
  // This is automatically run in `src/state/store.js` when the app
  // starts, along with any other actions named `init` in other modules.

  // eslint-disable-next-line no-unused-vars
  fetchCountries({ commit }) {
    return new Promise((resolve, reject) => {
      API.get('/address/country')
        .then(res => {
          commit('SET_COUNTRIES', res.message);
          resolve(res.message)
        })
        .catch(err => reject(err));
    });
  },

  // eslint-disable-next-line no-unused-vars
  fetchRegions({ commit }, { storeCount }) {
    return new Promise((resolve, reject) => {
      API.get('/address/regions', { storeCount })
        .then(res => {
          commit('SET_REGIONS', res.message);
          resolve(res.message)
        })
        .catch(err => reject(err));
    });
  },

  // eslint-disable-next-line no-unused-vars
  fetchProvinces({ commit }, { regionId, storeCount }) {
    return new Promise((resolve, reject) => {
      API.get('/address/provinces', { regionId, storeCount })
        .then(res => {
          commit('SET_PROVINCES', res.message);
          resolve(res.message)
        })
        .catch(err => reject(err));
    });
  },

  // eslint-disable-next-line no-unused-vars
  fetchCities({ commit }, { provinceId, storeCount }) {
    return new Promise((resolve, reject) => {
      API.get('/address/cities', { provinceId, storeCount })
        .then(res => {
          commit('SET_CITIES', res.message);
          resolve(res.message)
        })
        .catch(err => reject(err));
    });
  },

  // eslint-disable-next-line no-unused-vars
  fetchBarangays({ commit }, { cityId, storeCount }) {
    return new Promise((resolve, reject) => {
      API.get('/address/barangays', { cityId, storeCount })
        .then(res => {
          commit('SET_BARANGAYS', res.message);
          resolve(res.message)
        })
        .catch(err => reject(err));
    });
  }
}